// const _import =
export default [
  {
    path: '/group',
    component: () => import(/* webpackChunkName: "group" */ '@/pages/group/index.vue'),
    name: 'group.index',
    meta: {
      title: '用户组列表',
    },
  },
  {
    path: '/group/node/:id',
    component: () => import(/* webpackChunkName: "group" */ '@/pages/group/node.vue'),
    name: 'group.node',
    meta: {
      title: '用户组节点列表',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/group.js